<template>
  <b-modal
    id="new-payment-method-modal"
    header-class="anchor-modal"
    ref="newPaymentMethodModal"
    title="Create a New Payment Method"
    @keyup.enter.native="$refs.paymentForm.create()"
    size="lg"
    hide-footer
    scrollable
  >
    <payment-method-create
      @created="onCreateHandler"
      @reset="onReset"
      :show-account-type-field="showAccountTypeField"
      :show-option-field="showOptionField"
      :payment-method-type="paymentMethodType"
      :model="model"
      ref="paymentForm"
    />
  </b-modal>
</template>


<script>
import helper from '@/libs/helper';

import PaymentMethodCreate from '@/components/payments/create/PaymentMethodCreate';
import PAYMENT_MODEL from '@/components/payments/create/resources/model.json';

export default {
  props: {
    showAccountTypeField: {
      type: Boolean,
      default: true,
    },
    showOptionField: {
      type: Boolean,
      default: true,
    },
    paymentMethodType: {
      type: String,
      default: 'ACH',
    },
  },
  components: {
    PaymentMethodCreate,
  },
  data() {
    return {
      model: helper.copy(PAYMENT_MODEL),
    };
  },
  methods: {
    show() {
      this.$refs.newPaymentMethodModal.show();
    },
    hide() {
      this.$refs.newPaymentMethodModal.hide();
    },
    onCreateHandler(createPaymentMethod) {
      this.$notify({ group: 'alert', text: 'New Payment Method added.' });
      this.$emit('created', createPaymentMethod);
      this.onReset();
      this.hide();
    },
    onReset() {
      this.model = helper.copy(PAYMENT_MODEL);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/payments/create/PaymentMethodCreateModal.vue